import { auth, base } from './base';

function subscribeToUser(cb) {
  return auth.onAuthStateChanged(user => cb(user));
}

function getUserId(cb) {
  cb(auth.currentUser.uid);
}

function userId() {
  return auth.currentUser.uid;
}

function requireAdmin(nextState, replace, cb) {
  var dispose = auth.onAuthStateChanged(user => {
    const ref = base.database().ref(`users/${user.uid}`);
    ref.once('value', snapshot => {
      const { admin } = snapshot.val();
      if (admin) {
        replace({
          pathname: '/',
          state: { nextPathname: nextState.location.pathname }
        });
      }
      dispose();
      cb();
    });
  });
}

function loginRedirect(nextState, replace, cb) {
  auth.onAuthStateChanged(user => {
    if (user) {
      if (nextState.location.pathname !== '/') {
        replace({
          pathname: '/',
          state: { nextPathname: nextState.location.pathname }
        });
      }
    }
    cb();
  });
}

function getUser(cb) {
  cb(auth.currentUser);
}

function userIsLoggedIn() {
  return auth.currentUser ? true : false;
}

function signIn(username, password) {
  return auth.signInWithEmailAndPassword(username, password);
}

function signOut() {
  auth.signOut().then(() => {
    window.location.replace('/');
  });
}

function updateProfile(profile) {
  return auth.currentUser.updateProfile(profile);
}

function updateEmail(email) {
  return auth.currentUser.updateEmail(email);
}

function passwordReset(email) {
  return auth.sendPasswordResetEmail(email);
}

const errorMessages = {
  'auth/invalid-email': 'Email is not valid',
  'auth/user-disabled': 'Account has been disabled',
  'auth/user-not-found': 'No account could be found for this email address',
  'auth/wrong-password': 'Password is incorrect.',
  'auth/requires-recent-login':
    'Recent login require for this operation. Please log out and log back in to complete this change.',
  'auth/email-already-in-use': 'Email is already in use.',
  'auth/weak-password':
    'Password is too weak. Please choose a more complex password.'
};

export {
  getUser,
  signIn,
  signOut,
  subscribeToUser,
  passwordReset,
  updateEmail,
  updateProfile,
  getUserId,
  requireAdmin,
  loginRedirect,
  userIsLoggedIn,
  userId,
  errorMessages
};



// WEBPACK FOOTER //
// ./src/auth.js